<header class="relative w-full">
    <img class="w-full h-auto block" src="assets/images/partnerPortalRegistrationImage.png" alt="Hero Banner"/>
    <div class="uppercase !w-max absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white sm:text-xl lg:text-2xl font-bold drop-shadow-lg">
        {{title}}
    </div>
</header>
